class Users {
  constructor() {
    this.users = [];
  }
}

export default Users;

